<template>
  <!-- 选择账户 -->
  <section class="dapp" v-if="!account">
    <div class="null">{{ $t("noAccount") }}</div>
  </section>
  <section class="dapp" v-else>
    <nav class="tab-container">
      <ul class="tabs">
        <li @click="selectedTab = 1" :class="{ active: selectedTab == 1 }">
          <img src="@/assets/img/icon/Transfer.png" width="12" />
          <span>{{ $t("Transfer") }}</span>
        </li>
        <li @click="selectedTab = 2" :class="{ active: selectedTab == 2 }">
          <img src="@/assets/img/icon/Receive.png" width="12" />
          <span>{{ $t("Receive") }}</span>
        </li>
      </ul>
    </nav>
    <main>
      <article class="card" v-if="selectedTab == 1">
        <h4 class="text-center">{{ $t("l2_transfer_title") }}</h4>
        <div class="basic-group mt-32 flex-between">
          <input
            class="amount"
            type="number"
            :placeholder="$t('transfer_amount')"
            v-model="amount"
          />
          <p class="token select" @click="modalShow = true">
            <img :src="selectedToken.icon" width="24" />
            <span>{{ symbol }}</span>
          </p>
        </div>
        <label class="pointer" @click="amount = webUtil.fixedNumber(balance, 6)"
          >{{ $t("available") }}
          {{ balance ? webUtil.addCommas(balance, 6) : "--" }}
          {{ symbol }}</label
        >
        <textarea
          class="mt-32"
          type="text"
          :placeholder="'L1 ' + $t('receive_address')"
          v-model="destination"
        ></textarea>
        <label class="flex-between">
          <span>{{ $t("fee") }}</span>
          <span>{{ fee }} {{ symbol }}</span>
        </label>
        <a href="javascript:;" class="btn block-btn" @click="sendTransfer">{{
          $t("Transfer")
        }}</a>
      </article>
      <article class="card text-center" v-else>
        <h4>L1 {{ $t("receive_address") }}</h4>
        <div v-if="L1Address && qrcode">
          <img class="qrcode" :src="qrcode" width="180" />
          <p class="address">{{ L1Address }}</p>
          <a href="javascript:;" class="btn" @click="copyAction(L1Address)">{{
            $t("copy_address")
          }}</a>
        </div>
        <div v-else>
          <p class="null">{{ $t("no_address") }}</p>
        </div>
      </article>
    </main>
    <article
      class="footer-modal"
      @touchmove.prevent=""
      v-show="modalShow"
      @click.self="modalShow = false"
    >
      <div class="modal-content">
        <h5 class="flex-between">
          <span>{{ $t("select_token") }}</span
          ><span class="pointer" @click="modalShow = false">{{
            $t("cancel")
          }}</span>
        </h5>
        <ul class="list" v-if="tokenList && tokenList.length > 0">
          <li
            v-for="item in tokenList"
            :key="item.symbol"
            @click="toggleToken(item)"
            :class="{ active: symbol == item.symbol }"
          >
            <img :src="item.icon" width="24" />
            <span>{{ item.symbol }}</span>
          </li>
        </ul>
      </div>
    </article>
  </section>
</template>

<script>
import user from "@/assets/js/user";
import { parseEther, formatEther } from "@ethersproject/units";
import {Web3Provider} from "@ethersproject/providers"
export default {
  data() {
    return {
      selectedTab: 1,
      amount: "",
      destination: "",
      account: "",
      balance: "",
      selectedToken: {
        icon: require("@/assets/img/icon/logo.png"),
        symbol: "MATH",
        decimals: 18,
      },
      tokenList: [
        {
          icon: require("@/assets/img/icon/logo.png"),
          symbol: "MATH",
          decimals: 18,
        },
      ],
      L1Address: "",
      qrcode: "",
      gasLimit: "100000",
      gasPrice: "1",
      modalShow: false,
      web3Provider: null,
    };
  },
  computed: {
    decimals(){
      if(this.selectedToken){
        return this.selectedToken.decimals
      }
      return 18;
    },
    symbol(){
      if(this.selectedToken){
        return this.selectedToken.symbol
      }
      return 'MATH';
    },
    fee() {
      if (this.gasPrice == "" || this.gasLimit == "") {
        return 0;
      }
      return this.webUtil
        .BigNumber(this.gasPrice)
        .times(this.gasLimit)
        .div(Math.pow(10, 9))
        .toFixed(6);
    },
  },
  created() {
    this.getAccount();
  },
  methods: {
    toggleToken(item) {
      this.selectedToken = item;
      this.modalShow = false;
    },
    async getAccount() {
      this.$loading(1);
      let tries=0;
      let timer = setInterval(async()=>{
        tries++;
        if(window.ethereum){
          clearInterval(timer);
          this.web3Provider = new Web3Provider(window.ethereum);
          this.account = await this.web3Provider
            .getSigner()
            .getAddress()
            .catch((err) => {
              console.log(err);
            });

          this.getL1Address();
          this.getBalance();
          setInterval(() => {
            this.getBalance();
          }, 10000);
          this.$loading(0);
        }
        if(tries > 10){
          clearInterval(timer);
          this.$toast(this.$t("noMathExtension"));
          this.$loading(0);
        }
      }, 100);
    },
    async getBalance() {
      const balance = await this.web3Provider.getBalance(this.account);
      this.balance = formatEther(balance);
    },
    async sendTransfer() {
      let destination = this.webUtil.trimString(this.destination);
      let amount = this.webUtil.BigNumber(this.amount);
      let min = this.webUtil.BigNumber(Math.pow(10, -this.decimals));
      let max = this.webUtil.BigNumber(this.balance).minus(this.fee);

      if (!destination) {
        return this.$toast(this.$t("transfer_account_null"));
      }
      if(destination.indexOf('0x')==0){
        return this.$toast(this.$t("enter_target_address_first"));
      }
      if (!this.amount) {
        return this.$toast(this.$t("transfer_amount_null"));
      }
      if (amount.isLessThan(min)) {
        return this.$toast(
          this.$t("transfer_amount_min") + min.toFixed(this.decimals)
        );
      }
      if (amount.isGreaterThan(max)) {
        return this.$toast(this.$t("amount_not_enough"));
      }

      // 获取目标地址的L2地址
      let to = await user.getL2Account(destination).catch((err) => {
        console.log(err);
      });

      // 若未绑定过L2地址
      if (!to) {
        return this.$toast(this.$t("target_address_noL2"),3000);
      }

      if (to.toLowerCase() == this.account.toLowerCase()) {
        return this.$toast(this.$t("no_need_transfer"));
      }

      this.$loading(1);
      this.web3Provider
        .getSigner()
        .sendTransaction({
          to: to,
          value: parseEther(this.amount + ""),
        })
        .then(({ hash }) => {
          this.$loading(0);
          if (hash) {
            this.$toast(this.$t("transfer_success")).then(() => {
              this.destination = "";
              this.amount = "";
              this.getBalance();
            });
          } else {
            this.$toast(this.$t("transfer_fail"));
          }
        })
        .catch((err) => {
          this.$loading(0);
          this.$toast(this.$t("transfer_fail"));
          console.log(err);
        });
    },
    // 获取L1地址
    getL1Address() {
      user.getL1Account(this.account).then((res) => {
        if (res) {
          this.L1Address = res;
          this.webUtil.setQRCodeURL(this.L1Address).then((qrcode) => {
            this.qrcode = qrcode;
          });
        } else {
          // 计算L1地址
          this.L1Address = this.getL1FromL2(this.account);
          this.webUtil.setQRCodeURL(this.L1Address).then((qrcode) => {
            this.qrcode = qrcode;
          });
        }
      });
    },
  },
};
</script>
